export enum EventType {
  BLOCKED = 'blocked',
  APPOINTMENT = 'appointment'
}
